import { DSDivider, DSTableCell, Translate } from '@deltasierra/components';
import { t } from '@deltasierra/shared';
import React from 'react';
import { ScheduledPublishFragmentForFailedPublishesTable } from './__graphqlTypes/ScheduledPublishFragmentForFailedPublishesTable';

function Label(props: { label: string }): JSX.Element {
    return <span style={{ fontWeight: 'bold' }}>{`${props.label}: `}</span>;
}
Label.displayName = 'Label';

type Props = {
    row: ScheduledPublishFragmentForFailedPublishesTable;
};

export function FailedPublishesContentCell({ row }: Props): JSX.Element {
    const contentParts = [];
    if (row.builderTemplate) {
        contentParts.push(
            <>
                <Label label={t('ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE')} />
                <a href={`/contentBuilder?template=${row.builderTemplate.legacyId}`} rel="noreferrer" target="_blank">
                    <Translate keyId="COMMON.VIEW" />
                </a>
            </>,
        );
    }
    if (row.content.__typename === 'ScheduledPublishEmailContent') {
        contentParts.push(
            <>
                <Label label={t('ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT')} />
                {row.content.subject}
            </>,
        );
        contentParts.push(
            <>
                <Label label={t('ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML')} />
                <a href={row.content.htmlDownloadUrl} rel="noreferrer" target="_blank">
                    <Translate keyId="COMMON.VIEW" />
                </a>
            </>,
        );
        contentParts.push(
            <>
                <Label label={t('ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS')} />

                {row.content.recipientListDownloadUrl ? (
                    <a href={row.content.recipientListDownloadUrl} rel="noreferrer" target="_blank">
                        <Translate keyId="COMMON.DOWNLOAD" />
                    </a>
                )
                    : 'N/A'
                }
            </>,
        );
    }
    return (
        <DSTableCell>
            {...contentParts.map((content, index) => (
                <span key={index}>
                    {!!index && <DSDivider />} {content}{' '}
                </span>
            ))}
        </DSTableCell>
    );
}
FailedPublishesContentCell.displayName = 'FailedPublishesContentCell';
